import { Image } from "../../../Elements/Image/Image";

export function ImageCell({ imgSrc, imgAlt }) {
    return (
        <td>
            <Image
                imgLink={imgSrc}
                imgAlt={imgAlt}
            />
        </td>
    )
}